import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StoreAddress from '@components/storelocator/StoreAddress';
import classNames from 'classnames';
import formutils from '@common/utils/formutils';
const ProductBoutiqueReview = (props) => {
    var _a, _b, _c;
    const { requestSent, currentStore, days } = props;
    const hasAppintment = useMemo(() => {
        return requestSent.bookanappointment && (requestSent === null || requestSent === void 0 ? void 0 : requestSent.date);
    }, [requestSent]);
    const { t } = useTranslation();
    return (React.createElement("div", { className: "product-reserve__detail__reviews" },
        React.createElement("div", { className: "product-reserve__detail__review" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: classNames('col-24 product-reserve__detail__review-item ', { 'col-lg-12': hasAppintment }) },
                    React.createElement("h2", { className: "product-reserve__detail__review-header" }, `${t('notifyme.thankyou', {
                        title: formutils.labelByValue(requestSent === null || requestSent === void 0 ? void 0 : requestSent.title, (_a = props.formdef) === null || _a === void 0 ? void 0 : _a.title),
                        name: requestSent.firstname,
                    })}`),
                    React.createElement("div", { className: "product-reserve__detail__review-content" },
                        React.createElement("p", null, t('findinboutique.confirmation')))),
                hasAppintment && (React.createElement("div", { className: "col-24 product-reserve__detail__review-item col-lg-12" },
                    React.createElement("h2", { className: "product-reserve__detail__review-header" }, t('bookanappointment.appointmentdetails')),
                    React.createElement("div", { className: "product-reserve__detail__review-content" },
                        React.createElement("p", null,
                            t('label.date'),
                            ": ", requestSent === null || requestSent === void 0 ? void 0 :
                            requestSent.date),
                        React.createElement("p", null,
                            t('label.hour'),
                            ": ", (_c = (_b = days[requestSent === null || requestSent === void 0 ? void 0 : requestSent.date]) === null || _b === void 0 ? void 0 : _b.find((p) => (p === null || p === void 0 ? void 0 : p.value) == requestSent.hour)) === null || _c === void 0 ? void 0 :
                            _c.label))))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-24 product-reserve__detail__review-item col-lg-12" },
                    React.createElement("h2", { className: "product-reserve__detail__review-header" }, t('findinboutique.storeinfo')),
                    React.createElement("div", { className: "product-reserve__detail__review-content" },
                        React.createElement("p", null,
                            React.createElement(StoreAddress, { store: currentStore, showphone: true, showmail: true })),
                        React.createElement("p", null, `${t('findinboutique.message')}: ${requestSent.message}`))),
                React.createElement("div", { className: "col-24 product-reserve__detail__review-item col-lg-12" },
                    React.createElement("h2", { className: "product-reserve__detail__review-header" }, t('findinboutique.customerinfo')),
                    React.createElement("div", { className: "product-reserve__detail__review-content" },
                        React.createElement("p", null, `${requestSent.firstname} ${requestSent.lastname}`),
                        React.createElement("p", null, requestSent.email),
                        React.createElement("p", null, `${requestSent.phonePrefix} ${requestSent.phone}`))))),
        props.children));
};
export default ProductBoutiqueReview;
